<template>
  <div
    class="full-width row items-center justify-center"
    :style="`position:relative;height:${height};width:100%;`"
  >
    <q-carousel
      ref="carousel"
      animated
      v-model="slide"
      :height="`min(500px, ${height})`"
      @transition="slideChanged"
      control-type="outline"
      class="full-width"
      infinite
    >
      <q-carousel-slide
        v-for="(image, i) in images"
        :key="i"
        :name="i"
        class="q-pa-none"
        style="position: relative"
      >
        <PhotoSlider
          :key="`slider${i}`"
          :behavior="behavior"
          :image="image"
          :cid="cid"
        />
        <div
          v-if="image.title !== undefined || image.overline !== undefined"
          :class="`title-container q-pa-md text-white full-width justify-center column items-${image.textAlign}`"
        >
          <div
            v-if="image.featured && showFeatured"
            style="
              color: white;
              height: 30px;
              border-radius: 2px;
              border: 1px solid white;
              padding: 2px 8px 2px 6px;
              max-width: 90%;
            "
            class="row items-center content-center q-mb-sm no-wrap"
          >
            <q-icon
              class="q-pl-sm"
              name="star"
              size="17px"
              v-if="
                (typeof image.featured === 'boolean' ||
                  image.featured.boolean) &&
                !image.featured.tooltip
              "
            />
            <div v-if="image.featured.tooltip">
              <q-icon
                class="q-pl-sm"
                :name="
                  image.featured.tooltip.icon
                    ? image.featured.tooltip.icon
                    : 'star'
                "
                size="17px"
              >
                <q-tooltip>{{ image.featured.tooltip.text }}</q-tooltip>
              </q-icon>
            </div>
            <div
              :class="`q-pl-sm q-pr-sm`"
              style="
                text-transform: uppercase;
                font-weight: 700;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              <DDynamicText
                v-if="image.featured.dynamic"
                :dynamic="image.featured.dynamic"
                @show="showOrHideDynamic('showFeatured', $event)"
              />
              <span v-else-if="image.featured.text">{{
                image.featured.text
              }}</span>
              <span v-else>Featured</span>
            </div>
          </div>
          <div
            v-if="image.overline"
            class="overline non-selectable text-uppercase"
          >
            <DDynamicText
              v-if="image.overline.dynamic"
              :dynamic="image.overline.dynamic"
              :parentMetas="parentMetas"
            />
            <span v-else>{{ image.overline }}</span>
          </div>
          <div v-if="image.title" class="non-selectable title">
            <DDynamicText
              v-if="image.title.dynamic"
              :dynamic="image.title.dynamic"
              :parentMetas="parentMetas"
            />
            <span v-else>{{ image.title }}</span>
          </div>
          <div v-if="image.caption" class="caption">
            <DDynamicText
              v-if="image.caption.dynamic"
              :dynamic="image.caption.dynamic"
              :parentMetas="parentMetas"
            />
            <span v-else>{{ image.caption }}</span>
          </div>
        </div>
      </q-carousel-slide>
    </q-carousel>
    <div class="controls text-white row items-start q-pt-md full-width">
      <div v-if="componentData.data.images.length > 1" class="col-3 q-pl-md">
        <q-icon
          class="cursor-pointer"
          name="collections"
          size="20px"
          color="white"
          @click.stop="togglePicker"
        ></q-icon>
      </div>
      <div
        v-if="componentData.data.images.length > 1"
        class="row col justify-center items-center content-center"
      >
        <q-icon
          class="cursor-pointer q-pr-sm"
          @click.stop="$refs.carousel.previous()"
          name="chevron_left"
          size="24px"
        />
        <div
          style="font-size: 14px; line-height: 18px; font-weight: 600"
          class="text-white"
        >
          {{ `${slide + 1}/${componentData.data.images.length}` }}
        </div>
        <q-icon
          class="cursor-pointer q-pl-sm"
          @click.stop="$refs.carousel.next()"
          name="chevron_right"
          size="24px"
        />
      </div>
      <div class="col-3 text-center"></div>
    </div>
    <DFullScreenCarouselPicker
      @show="showPicker"
      @hide="hidePicker"
      ref="picker"
      @tileClick="tileClick"
      :behavior="behavior"
      :componentData="componentData"
      :height="height"
      class="full-width"
    />
  </div>
</template>

<script>
import PhotoSlider from "./PhotoSlider.vue";
import DFullScreenCarouselPicker from "./DFullScreenCarouselPicker.vue";
import mixin from "../../d-card-mixins";
import getImgUrl from "../../mixins/get-img-url";
import DDynamicText from "../DDynamicText/DDynamicText.vue";

export default {
  name: "DFullScreenCarousel",
  components: { PhotoSlider, DFullScreenCarouselPicker, DDynamicText },
  mixins: [mixin, getImgUrl],
  props: {
    componentData: {
      type: Object,
      default: null,
    },
    height: {
      type: String,
      required: true,
    },
    behavior: {
      type: String,
      default: "agent",
    },
    parentMetas: {
      type: Object,
      require: false,
      default: () => {},
    },
    cid: {
      type: String,
      default: "cenora",
    },
  },
  data() {
    return {
      slide: 0,
      pathStore: "componentOverlay.fscstate",
      patchFlag: true,
      pickerShown: false,
      showFeatured: true,
    };
  },
  computed: {
    controlHeight: {
      get() {
        return parseInt(this.height.replace("px", ""));
      },
    },
    meetingSlide: {
      get() {
        if (this.behavior === "consumer") {
          return this.$cardStore.get(`${this.pathStore}.slide`);
        } else {
          return this.slide;
        }
      },
      set(val) {
        if (this.behavior === "consumer") {
          this.$cardStore.set(`${this.pathStore}.slide`, val);
        } else {
          this.slide = val;
        }
      },
    },
    meetingPickerShown: {
      get() {
        if (this.behavior === "consumer") {
          return this.$cardStore.get(`${this.pathStore}.pickerShown`);
        } else {
          return this.pickerShown;
        }
      },
      set(val) {
        if (this.behavior === "consumer") {
          this.$cardStore.set(`${this.pathStore}.pickerShown`, val);
        } else {
          this.pickerShown = val;
        }
      },
    },
    images: {
      get() {
        return this.componentData.data.images.map((item) => {
          const src = this.getImgUrl({
            ...item,
            url: `${this.componentData.baseUrl}${item.src}`,
            poster: `${this.componentData.baseUrl}${item.poster}`,
          });

          return {
            title: item?.title ? item.title : null,
            overline: item?.overline ? item.overline : null,
            caption: item?.caption ? item.caption : null,
            imgStyle: item?.style ? item.style : null,
            textAlign: item?.textAlign
              ? item.textAlign.replace("left", "start").replace("right", "end")
              : "center",
            featured: item?.featured ? item.featured : false,
            type:
              /\.webp|\.j(p|pe)g|\.gif/gi.test(src) && /cenora\.io/gi.test(src)
                ? "image"
                : item.type,
            src,
            section: item.section,
          };
        });
      },
    },
  },
  mounted() {
    this.slide = this.componentData.state.slide;
    this.initializeSlide(this.slide);
    if (this.behavior === "consumer") {
      this.$watch("meetingSlide", (val) => {
        this.setSlide(val);
      });
      this.$watch("meetingPickerShown", (val) => {
        if (val) {
          this.$refs.picker.open(false);
        } else {
          this.$refs.picker.close(false);
        }
      });
    }
  },
  updated() {
    this.initializeSlide(this.slide);
  },
  methods: {
    slideChanged(slide) {
      // console.log(slide);
      this.meetingSlide = slide;
      this.initializeSlide(slide);
      this.$refs.picker.close();
    },
    initializeSlide(slide) {
      if (this.behavior == "consumer") {
        this.meetingSlide = slide;
      } else {
        this.slide = slide;
      }
    },
    setSlide(slide) {
      this.$refs.carousel.goTo(slide);
    },
    tileClick(index) {
      this.meetingSlide = index;
    },
    togglePicker() {
      this.$refs.picker.toggle();
    },
    showPicker() {
      this.meetingPickerShown = true;
    },
    hidePicker() {
      this.meetingPickerShown = false;
    },
    showOrHideDynamic(prop, value) {
      this[prop] = value;
    },
  },
};
</script>
<style lang="scss" s scoped>
.controls {
  width: 100%;

  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  position: absolute;
  left: 0;
  top: 0;
}
.title-container {
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 1.1em;
  z-index: 20;

  .overline {
    font-size: 9px;
    line-height: 16px;
    font-weight: 800;
    opacity: 0.8;
    letter-spacing: 0.02px;
  }

  .title {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: -0.02px;
  }

  .caption {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.02px;
  }
}
</style>
